export const ROUTER_URL = {
  Home: '/',
  // Auth
  UserProfile: '/me/profile',
  Auth: '/auth',
  Login: '/auth/login',
  // Item Management
  ItemManagement: '/item-management',
  ItemManagementImportDate: '/item-management/import-date',
  ItemManagementImportDateDetail: '/item-management/import-date/:id',
  ItemManagementQCDate: '/item-management/qc-date',
  ItemManagementDeliveredDate: '/item-management/delivered-date',
  ItemManagementViewLogs: '/item-management/:tab/view-logs',
  // Engineering Management
  EngineeringManagement: '/engineering-management',
  EngineeringManagementMajorProjects: '/engineering-management/major-projects',
  EngineeringManagementMajorProjectsDetail:
    '/engineering-management/major-projects/:id',
  EngineeringManagementSpecialProjects:
    '/engineering-management/special-projects',
  EngineeringManagementSpecialProjectsDetail:
    '/engineering-management/special-projects/:id',
  EngineeringManagementItemFault: '/engineering-management/items-fault',
  EngineeringManagementAddItemFault: '/engineering-management/items-fault/add',
  EngineeringManagementItemFaultsDetail:
    '/engineering-management/items-fault/:id',
  EngineeringManagementProductionFault:
    '/engineering-management/productions-fault',
  EngineeringManagementAddProductionFault:
    '/engineering-management/productions-fault/add',
  EngineeringManagementProductionFaultsDetail:
    '/engineering-management/productions-fault/:id',
  EngineeringManagementSummary: '/engineering-management/summary',
  EngineeringManagementViewLogs: '/engineering-management/:tab/view-logs',
  EngineeringManagementSpecialProjectUploadCost:
    '/engineering-management/special-projects/upload-cost',
  // User Management
  User: '/user',
  UserManagement: '/user/user-management',
  UserManagementOffice: '/user/user-management/office',
  UserManagementSubcontractor: '/user/user-management/subcontractor',
  UserManagementProduction: '/user/user-management/production',
  UserManagementEngineering: '/user/user-management/engineering',
  // Role Management
  RoleManagement: '/user/role-management',
  RoleManagementDetail: '/user/role-management/:id',
  RoleManagementAdd: '/user/role-management/add',
  RoleManagementEdit: '/user/role-management/edit/:id',
  // Engineering Team
  EngineeringTeam: '/user/engineering-team',
  // Subcontractor Management
  Subcontractor: '/subcontractor',
  SubcontractorAll: '/subcontractor/all',
  SubcontractorLaserCutting: '/subcontractor/laser-cutting',
  SubcontractorLaserCuttingDetail: '/subcontractor/laser-cutting/:id',
  SubcontractorInsulationCutting: '/subcontractor/insulation-cutting',
  SubcontractorInsulationCuttingDetail: '/subcontractor/insulation-cutting/:id',
  SubcontractorRollForming: '/subcontractor/roll-forming',
  SubcontractorRollFormingDetail: '/subcontractor/roll-forming/:id',
  SubcontractorFolding: '/subcontractor/folding',
  SubcontractorFoldingDetail: '/subcontractor/folding/:id',
  SubcontractorViewLogs: '/subcontractor/:tab/view-logs',
  // Special Project List
  SpecialProjectList: '/special-project-list',
  SpecialProjectDetail: '/special-project-list/:id',
  // Factory Management
  FactoryManagement: '/factory-management',
  FactoryManagementAssignEmployee: '/factory-management/employee-assignment',
  FactoryManagementAssignEmployeeViewLogs:
    '/factory-management/employee-assignment/view-log',
  FactoryManagementJobsDisplay: '/factory-management/jobs-display',
  FactoryManagementJobsSorting: '/factory-management/jobs-sorting',
  FactoryManagementProcessLog: '/factory-management/process-log',
  FactoryManagementProcessLogDetail: '/factory-management/process-log/:id',
  FactoryManagementSummary: '/factory-management/summary',
  FactoryManagementSummaryDetail: '/factory-management/summary/:id',
  JobsManagementViewLog: '/factory-management/jobs/view-log',
  // Company Management
  CompanyManagement: '/company-management',
  // Setting
  Settings: '/settings',
  EditSettings: '/settings/edit',
  // Rate Setting
  RateSetting: '/rate-setting',
  EditRateSettings: '/rate-setting/edit',
  EasterEgg: '/easter-egg',
  // Display
  Display: '/display',
  DisplayOne: '/display/display-one',
  DisplayTwo: '/display/display-two',
  // Process QA
  ProcessQA: '/process-qa',
  ProcessQAMajor: '/process-qa/major',
  ProcessQASpecial: '/process-qa/special',
  ProcessQAViewLogs: '/process-qa/:tab/view-logs',
  // Process Time
  ProcessTimeMajor: '/process-time-major',
  ProcessTimeMajorDetail: '/process-time-major/:id',
  ProcessTimeMajorViewLogs: '/process-time-major/view-logs/:logTab',
  ProcessTimeMajorUploadComponent:
    '/process-time-major/upload-process-time-major',
  ProcessTimeSpecial: '/process-time-special',
  ProcessTimeSpecialDetail: '/process-time-special/:id',
  ProcessTimeSpecialViewLogs: '/process-time-special/view-logs/:logTab',
  ProcessTimeSpecialUpload: '/process-time-special/upload-process-time-special',
  // Process Time Config
  ProcessTimeConfig: '/process-time-config',
  ProcessTimeConfigSettings: '/process-time-config/settings',
  ProcessTimeConfigSettingsEdit: '/process-time-config/settings/edit',
  ProcessTimeConfigTables: '/process-time-config/tables',
  ProcessTimeConfigTablesEdit: '/process-time-config/tables/:id',
  ProcessTimeConfigTablesNew: '/process-time-config/tables/new',
  ProcessTimeConfigTablesUpload: '/process-time-config/tables/upload/:tableId',
  ProcessTimeConfigDuctTypes: '/process-time-config/duct-types',
  // Process Time - Item View
  ProcessTimeItemView: '/process-time-item-view',
  ProcessTimeItemViewMajor: '/process-time-item-view/Major',
  ProcessTimeItemViewSpecial: '/process-time-item-view/Special',
  ProcessTimeItemViewLogs: '/process-time-item-view/:tab/view-logs/:logTab',
  // Process Time - Activity Log
  ProcessTimeActivityLog: '/process-time-activity-log',
};

export const USER_TAB_PATTERN = `${ROUTER_URL.UserManagement}/:tab`;
export const SUBCONTRACTOR_TAB_PATTERN = `${ROUTER_URL.Subcontractor}/:tab`;
export const SUBCONTRACTOR_TAB_DETAIL_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/:id`;
export const SUBCONTRACTOR_DETAIL_PATTERN = '/subcontractor/{type}/{id}';
export const SUBCONTRACTOR_VIEW_LOGS_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/view-logs`;
export const ENGINEERING_M_TAB_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab`;
export const ITEM_M_TAB_PATTERN = `${ROUTER_URL.ItemManagement}/:tab`;
export const ITEM_M_TAB_DETAIL_PATTERN = `${ROUTER_URL.ItemManagement}/:tab/:id`;
export const ITEM_M_VIEW_LOGS_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/view-logs`;
export const FACTORY_MANAGEMENT_TAB_PATTERN = `${ROUTER_URL.FactoryManagement}/:tab`;
export const FACTORY_MANAGEMENT_TAB_DETAIL_PATTERN = `${ROUTER_URL.FactoryManagement}/:tab/:id`;
export const ENGINEERING_M_TAB_DETAIL_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab/:id`;
export const ENGINEERING_M_VIEW_LOGS_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab/view-logs`;
export const DISPLAY_PATTERN = `${ROUTER_URL.Display}/:display`;
export const PROCESS_QA_TAB_PATTERN = `${ROUTER_URL.ProcessQA}/:tab`;
export const PROCESS_QA_VIEW_LOGS_PATTERN = `${ROUTER_URL.ProcessQA}/:tab/view-logs`;
export const PROCESS_TIME_CONFIG_TAB_PATTERN = `${ROUTER_URL.ProcessTimeConfig}/:tab`;
export const PROCESS_TIME_CONFIG_TAB_DETAIL_PATTERN = `${ROUTER_URL.ProcessTimeConfig}/:tab/:id`;
export const PROCESS_TIME_ITEM_VIEW_TAB_PATTERN = `${ROUTER_URL.ProcessTimeItemView}/:tab`;
export const PROCESS_TIME_ITEM_VIEW_LOGS_PATTERN = `${ROUTER_URL.ProcessTimeItemView}/:tab/view-logs/:logTab`;
